<template>
    <div>
        <el-row :gutter="20" class="background-main-page">
            <el-col :span="24" class="text-left header-box">
                <span class="export-order-title">Export Order Excel</span>
            </el-col>
            <el-col :span="12">
                <el-tabs v-model="typeSelect" type="card" >
                    <el-tab-pane
                        v-for="item in tabsListExport"
                        :key="`key-${item.name}`"
                        :label="item.name"
                        :name="item.value"
                        class="tab-box"
                    >
                        <el-form status-icon ref="ruleForm" label-width="160px" label-position="left">
                            <el-form-item label="เลือกวันที่">
                                <el-date-picker
                                    v-model="datePick"
                                    type="daterange"
                                    range-separator="To"
                                    start-placeholder="Start date"
                                    end-placeholder="End date"
                                    format="dd-MM-yyyy"
                                    value-format="yyyy-MM-dd"
                                    class="export-order-datepick" />
                            </el-form-item>
                            <el-form-item label="สถานะออเดอร์">
                                <MultipleCheckboxInSelect
                                    :constantList="constantStatus"
                                    :itemList="statusList"
                                    :maxLength="statusList.length"
                                    :objectKey="objectKryStatus"
                                    :isClear="isClearForm"
                                    :isCreatecomponent="isCreatecomponentStatus"
                                    @selectList="onSelectedStatusList"
                                    @clearSelect="isClearForm = false"
                                    />
                            </el-form-item>
                            <el-form-item label="ขนส่ง">
                                <MultipleCheckboxInSelect
                                    :constantList="constantCourier"
                                    :itemList="courierList"
                                    :maxLength="courierList.length"
                                    :objectKey="objectKryCourier"
                                    :isClear="isClearCourier"
                                    :isCreatecomponent="isCreatecomponentCourier"
                                    @selectList="onSelectedCourierList"
                                    @clearSelect="isClearCourier = false"
                                    />
                            </el-form-item>
                            <el-form-item label="ร้านค้า">
                                <div class="box-list-export-order text-left" >
                                    <div class="export-order-box-all-shop">
                                        <q-checkbox v-model="isAllShop" indeterminate-value="some" class="q-checkbox-all-shop"/>
                                        <span>เลือกทั้งหมด <span v-if="checkListShopId.length > 0">{{checkListShopId.length}} ร้านค้า</span></span>
                                    </div>
                                    <div style="padding:10px 20px;">
                                        <el-input
                                            placeholder="ค้นหา"
                                            prefix-icon="el-icon-search"
                                            @input="onSearchShop"
                                            v-model="searchShop"
                                            clearable>
                                        </el-input>
                                    </div>
                                    <div v-if="loadingGetShop">
                                        <q-linear-progress query size="5px"/>
                                    </div>
                                    <div class="div-virtual-box">
                                        <q-virtual-scroll
                                            :items="shopAllList"
                                            bordered
                                            :virtual-scroll-item-size="48"
                                            :virtual-scroll-sticky-size-start="48"
                                            :virtual-scroll-sticky-size-end="32"
                                            class="virtual-box"
                                        >
                                            <template v-slot="{ item, index }">
                                            <q-item :key="index" class="pa-0">
                                                <q-item-section>
                                                <q-item-label>
                                                    <div class="row">
                                                        <div class="col-auto"><q-checkbox class="box-all-and-choose-shop-list-item margin-t-10" v-model="checkListShopId" :val="item.shopId"/></div>
                                                        <div class="col-auto box-all-and-choose-shop-list-item-shopname"><span class="box-all-and-choose-shop-list-item user-code">{{item.userCode}} -</span></div>
                                                        <div class="col box-all-and-choose-shop-list-item-shopname"><span class="box-all-and-choose-shop-list-item shop-name">{{item.shopName}}</span></div>
                                                    </div>
                                                </q-item-label>
                                                </q-item-section>
                                            </q-item>
                                            </template>
                                        </q-virtual-scroll>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-form>
                        <div>
                            <el-button class="button-process" @click="processExcel">Process</el-button>
                            <el-button class="button-clear" plain @click="onFormClear">Clear</el-button>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="12" class="export-order-box-choose-shop">
                <span>รายการที่เลือก</span>
                <el-button class="button-export-order-all" :disabled="showExportAll" @click="exportNodeServerAll(false, null)">Export Order All ({{ countOrder }})</el-button>
            </el-col>
            <el-col :span="12" class="background-table-page">
                <div class="box-list-export-order text-left">
                    <q-virtual-scroll
                        type="table"
                        :virtual-scroll-item-size="48"
                        :virtual-scroll-sticky-size-start="48"
                        :virtual-scroll-sticky-size-end="32"
                        :items="orderShopList"
                        class="table-order-list-count"
                        >
                        <template v-slot:before>
                            <thead class="thead-sticky text-left table-select-box">
                                <tr class="table-select-box">
                                    <th v-for="col in columnsTable" :key="`columnsTable-${col.name}`">
                                        <span class="export-order-table-head">{{ col.name }}</span>
                                    </th>
                                </tr>
                                <template v-if="orderShopList.length === 0 && !loadingGetOrderDetail">
                                    <tr>
                                        <td colspan="3" class="no-data-box">
                                            <span class="txt-no-data">ไม่พบข้อมูล</span>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="loadingGetOrderDetail">
                                    <tr style="height:0px">
                                        <td colspan="3" style="text-align: center;padding:0 !important">
                                            <q-linear-progress query size="5px"/>
                                        </td>
                                    </tr>
                                </template>
                            </thead>
                        </template>
                        <template v-slot="{ item: row, index }">
                            <tr :key="index">
                                <td v-for="col in columnsTable" :key="`${index}-${col.name}`">
                                    <template v-if="col.prop === 'shopId'">
                                        <el-button @click="exportNodeServerAll(true, row)" icon="el-icon-download" plain size="mini" class="btn-order-product-download">Order</el-button>
                                        <el-button @click="exportProductExcel(row)" icon="el-icon-download" plain size="mini" class="btn-order-product-download">Product</el-button>
                                    </template>
                                    <template v-else-if="col.prop === 'shopName'">
                                        <span class="box-list-export-order-select">{{ row.userCode }} - {{row.shopName}}</span>
                                    </template>
                                    <template v-else>
                                        <span class="box-list-export-order-select">{{ row[col.prop] }}</span>
                                    </template>
                                </td>
                            </tr>
                        </template>
                    </q-virtual-scroll>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import mixinExcel from '@/mixins/exportExcel.js'
import payment from '@/mixins/paymentUtility.js'
import Axios from 'axios'
import MultipleCheckboxInSelect from '@/components/helper/MultipleCheckboxInSelect.vue'
import { serverConfig } from '@/config/serverConfig.js'
export default {
    name: 'ExportOrder',
    mixins: [mixinExcel, payment],
    components: { MultipleCheckboxInSelect },
    data () {
        return {
            searchShop: '',
            loadingTable: false,
            datePick: [this.$dayjs(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), this.$dayjs(new Date()).format('YYYY-MM-DD')],
            orderShopList: [],
            showExportAll: true,
            shopAllList: [],
            typeSelect: '1',
            limit: 3000,
            offset: 0,
            isFetch: false,
            dataList: [],
            unsubscribeFireStore: null,
            countOrder: 0,
            checkListShopId: [],
            columnsTable: [
                { name: 'ร้านค้า', prop: 'shopName' },
                { name: 'จำนวนออเดอร์', prop: 'countOrder' },
                { name: 'จัดการ', prop: 'shopId' }
            ],
            loadingGetShop: false,
            loadingGetOrderDetail: false,
            imeout: null,
            countAllShop: 0,
            tabsListExport: [
                {
                    name: 'วันที่สร้างออเดอร์',
                    value: '1'
                },
                {
                    name: 'Pickup Date',
                    value: '2'
                }
            ],
            selectStatusList: [],
            constantStatus: [],
            objectKryStatus: {},
            statusList: [],
            selectCourierList: [],
            constantCourier: [],
            objectKryCourier: {},
            courierList: [],
            isClearForm: false,
            isClearCourier: false,
            isCreatecomponentStatus: false,
            isCreatecomponentCourier: false,
            constantStatusAll: []
        }
    },
    async mounted () {
        this.getAllshop()
        await this.onGetOrderStatusList()
        await this.onGetProviderTypeList()
    },
    computed: {
        isAllShop: {
            get: function () {
                if (this.checkListShopId.length === 0) {
                    return false
                } else if (this.checkListShopId.length === this.countAllShop) {
                    return true
                } else {
                    return 'some'
                }
            },
            set: function (value) {
                if (value) {
                    this.checkListShopId = this.shopAllList.map(e => e.shopId)
                } else {
                    this.checkListShopId = []
                }
            }
        }
    },
    watch: {
        typeSelect (newVal) {
            this.orderShopList = []
            this.showExportAll = true
            this.countOrder = 0
        }
    },
    methods: {
        async getAllshop (search = '') {
            this.loadingGetShop = true
            this.countAllShop = 0
            try {
                const param = {
                    search: search
                }
                let res = await fgApi.shop.getAllShopExportOrderExcel(param)
                if (res.data) {
                    this.shopAllList = res.data
                    this.countAllShop = res.countAll
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.loadingGetShop = false
        },
        onSearchShop (value) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.shopAllList = []
                this.getAllshop(value)
            }, 500)
        },
        async processExcel () {
            if (this.checkListShopId.length === 0) {
                this.$notify.error({
                    title: 'Error',
                    message: 'กรุณาเลือกร้านค้า'
                })
                return
            }
            this.loadingGetOrderDetail = true
            this.orderShopList = []
            this.showExportAll = true
            this.countOrder = 0
            let param = {
                from: this.datePick[0] + ' 00:00:00',
                to: this.datePick[1] + ' 23:59:59',
                shop_ids: this.checkListShopId,
                is_pickedup_date: this.typeSelect === '2',
                order_status_ids: this.selectStatusList,
                courier_provider_ids: this.selectCourierList
            }
            try {
                let res = await fgApi.order.countExportOrder(param)
                if (res.success) {
                    this.orderShopList = res.data
                    let count = 0
                    res.data.forEach(e => {
                        count = count + e.countOrder
                    })
                    this.countOrder = count
                    if (res.data.length > 0) {
                        this.showExportAll = false
                    } else {
                        this.showExportAll = true
                    }
                    this.loadingGetOrderDetail = false
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }

            this.loadingGetOrderDetail = false
        },
        async exportProductExcel (objShop) {
            this.$loading()
            let excelHead = this.excelProductHeader
            let res = await fgApi.order.getAllProductShopId({ shop_id: objShop.shopId })
            console.log(res)
            res.data.forEach((product) => {
                let dimension = {
                    width: 0,
                    height: 0,
                    length: 0
                }
                if (product.dimension && product.dimension !== 'null') {
                    dimension = JSON.parse(product.dimension)
                }
                let arrData = [
                    product.productId, product.sku, product.name, product.price, product.stockType, product.weight,
                    dimension.width, dimension.length, dimension.height, product.color, product.category, product.status,
                    this.$dayjs(product.createdAt).format('YYYY-MM-DD HH:mm:ss'), product.deletedAt ? this.$dayjs(product.deletedAt).format('YYYY-MM-DD HH:mm:ss') : '-'
                ]
                excelHead.push(arrData)
            })
            this.saveExcel(excelHead, objShop.shopName + '_products')
            this.$loading().close()
            console.log(objShop.shopId)
        },
        async csRawCaseExport () {
            if (this.isFetch) {
                this.isFetch = false
                this.offset = 0
                this.dataList = []
                return
            }
            this.$loading()
            let param = {
                from: this.$dayjs(new Date()).subtract(14, 'day').format('YYYY-MM-DD') + ' 00:00:00',
                to: this.$dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                status_array: [
                    0, 3, 4, 5, 6, 10
                ],
                courier_ids: [1],
                is_pickedup_date: false,
                limit: this.limit,
                offset: this.offset
            }
            console.log(param)
            try {
                let res = await fgApi.order.exportOrderStatusArray(param)
                // console.log(res)
                if (res.success) {
                    if (res.data.length > 0) {
                        this.offset = this.offset + 3000
                        // this.dataList.push(res.data)
                        res.data.forEach((order) => {
                            let status = `${this.getOrderStatus(order.status)} ${order.deletedAt ? '(ลบ)' : ''}`

                            let arrData = [
                                `'${order.orderNumber}`,
                                `${order.trackingNumber}`,
                                `'${order.shippingName}`,
                                `'${order.shippingPhoneNumber}`,
                                `'${order.shippingPhoneNumberSec}`,
                                `'${order.shippingAddress}`,
                                `'${order.shippingSubDistrict}`,
                                `'${order.shippingDistrict}`,
                                `${order.shippingProvince}`,
                                `${order.shippingZipcode}`,
                                `'${order.shippingTag}`,
                                `'${this.getCourier(order.courierId)}`,
                                `'${this.getPaymentType(order.paymentType)}`,
                                `'${order.netPrice}`,
                                `'${order.deliveryCost}`,
                                `'${'0'}`,
                                `${order.actualWeight}`,
                                `'${order.dimWeight}`,
                                `'${this.$dayjs(order.createdAt).format('YYYY-MM-DD HH:mm:ss')}`,
                                `'${order.note}`,
                                order.paymentDate ? `'${this.$dayjs(order.paymentDate).format('YYYY-MM-DD HH:mm:ss')}` : '',
                                `'${this.getBank(order.paymentBank)}`,
                                `${order.paymentAmount}`,
                                `'${this.$dayjs(order.updatedAt).format('YYYY-MM-DD HH:mm:ss')}`,
                                `'${status}`,
                                `'${this.getPurchaseChannel(order.purchaseChannel)}`,
                                order.employeeId ? `'${order.employeeFirstName} ${order.employeeLastName}` : `'${order.userFirstName} ${order.userLastName}`,
                                `'${this.getPrintKeyword(order.isPrint)}`,
                                `'${order.userEmail}`,
                                `${order.userCode}`,
                                `${order.shopName}`,
                                `${order.shopId}`,
                                `${order.shopCode}`,
                                order.agentId ? `'${order.agentName}` : "'-",
                                `'${this.$dayjs(order.pickedUpAt).format('YYYY/MM/DD HH:mm:ss')}`,
                                `${order.codServicePrice}`,
                                `${order.delServicePrice}`,
                                `'${order.returnWeight}`
                            ]
                            this.dataList.push(arrData)
                        })
                        this.csRawCaseExport()
                    } else {
                        let header = this.excelOrderHeader
                        header = header.concat(this.dataList)

                        this.isFetch = true
                        // console.log(header)
                        await this.saveCsv(header, 'csRawOrder')
                        this.$loading().close()
                        this.csRawCaseExport()
                    }
                }
            } catch (error) {
                console.log(error)
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
                this.$loading().close()
            }
        },
        async exportNodeServerAll (isSelectShop = false, shop = null) {
            let shopId = []
            let isAllShop = false
            if (isSelectShop) {
                shopId = [shop.shopId]
            } else {
                shopId = [...this.checkListShopId]
                if (this.countAllShop === this.checkListShopId.length) {
                    shopId = []
                    isAllShop = true
                } else {
                    isAllShop = false
                }
            }

            this.$loading()
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            let param = {
                from: this.datePick[0] + ' 00:00:00',
                to: this.datePick[1] + ' 23:59:59',
                shop_ids: shopId,
                is_all_shop: isAllShop,
                is_pickedup_date: this.typeSelect === '2',
                order_status_ids: this.selectStatusList,
                limit: 10000,
                env: env(this.$store.get('envSystem/mode'))
            }
            try {
                let response = await Axios({
                    method: 'post',
                    url: `${serverConfig.nodeServerUrl}/v1/excel/oms/export-oms-csv`,
                    data: param
                })
                console.log(response)
                if (response.data.success) {
                    if (this.unsubscribeFireStore) {
                        this.unsubscribeFireStore()
                    }
                    this.unsubscribeFireStore = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).firestore().collection('export_order_oms').doc(response.data.id).onSnapshot(doc => {
                        console.log(doc.data().status)
                        if (doc.data().status === 'success') {
                            this.getFileNodeServer(response.data.id, isSelectShop, shop)
                        } else if (doc.data().status === 'error') {
                            this.$notify.error({
                                title: 'Error',
                                message: doc.data().message.message
                            })
                            this.$loading().close()
                        }
                    })
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: response.data
                    })
                    this.$loading().close()
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
                this.$loading().close()
            }
        },
        async getFileNodeServer (id, isSelectShop, shop) {
            console.log('download file')
            if (this.unsubscribeFireStore) {
                this.unsubscribeFireStore()
            }
            let fileName = ''
            if (isSelectShop) {
                fileName = shop.shopName + '_orders'
            } else {
                fileName = this.$dayjs(new Date()).format('YYYY-MM-DD') + '_all_orders_'
            }
            window.open(`${serverConfig.nodeServerUrl}/v1/excel/oms/get-file-export-oms?id=${id}&filename=${fileName}`, '_blank')
            this.$loading().close()
        },
        async onGetOrderStatusList () {
            try {
                const res = await fgApi.courier.getOrderStatusType()
                if (res.success) {
                    this.constantStatusAll = res.data.map(e => {
                        return e.id
                    })
                    this.statusList = res.data.filter(e => {
                        return e.id === 5 || e.id === 6 || e.id === 8
                    }).map(status => {
                        this.objectKryStatus[status.id] = status.description
                        return {
                            value: status.id,
                            label: status.description
                        }
                    })
                    this.constantStatus = this.statusList.map(e => {
                        return e.value
                    })
                    this.isCreatecomponentStatus = true
                }
            } catch (err) {
                this.$notify.error({
                    title: 'Error',
                    message: err
                })
            }
        },
        async onGetProviderTypeList () {
            try {
                const res = await fgApi.courier.getProviderType()
                if (res.success) {
                    this.constantCourier = res.data.map(e => {
                        return e.courierProviderId
                    })
                    this.courierList = res.data.map(e => {
                        this.objectKryCourier[e.courierProviderId] = e.name
                        return {
                            value: e.courierProviderId,
                            label: e.name,
                            isPartner: e.isPartner
                        }
                    })
                    this.isCreatecomponentCourier = true
                }
            } catch (err) {
                this.$notify.error({
                    title: 'Error',
                    message: err
                })
            }
        },
        onSelectedStatusList (val) {
            if (val.length === 3) {
                this.selectStatusList = this.constantStatusAll
            } else {
                this.selectStatusList = val
            }
        },
        onSelectedCourierList (val) {
            this.selectCourierList = val
        },
        onFormClear () {
            this.checkListShopId = []
            this.datePick = [this.$dayjs(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), this.$dayjs(new Date()).format('YYYY-MM-DD')]
            this.isClearForm = true
            this.isClearCourier = true
            this.onGetProviderTypeList()
        }
    }
}
</script>

<style lang="scss" scoped>
$txt-color: #666666;
.pa-0 {
    padding: 0;
}
.export-order-title {
    font-size: 26px;
    color: #000000DE;
    font-weight: 400;
    font-family: kanit;
}
.export-order-options {
    font-size: 13px;
    margin-right: 10px;
    letter-spacing: 1.69px;
    color: #00000099;
    font-weight: 400;
    font-family: kanit;
}
.select-main-export-order {
    margin-right: 0px !important;
    span {
        font-size: 15px;
        letter-spacing: 0.75px;
        color: #00000099;
        font-weight: 500;
        font-family: kanit;
    }
}
.button-cs-raw{
    margin-left: 10px !important;
    padding-bottom: 11px;
    color: white;
    background-color: #1D8649;
    font-weight: bold;
    font-size: 15px;
    letter-spacing: 0.75px;
    font-weight: 500;
    span {
        font-family: kanit;
    }
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-transfer-panel{
    width: 300px;
    height:400px;
}
.el-transfer-panel__list.is-filterable{
    height:300px;
    font-size:16px;
    text-align: left;
    width: 100%;
}
.date {
    .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
        width: 560px;
    }
}
.el-transfer-panel__item.el-checkbox {
    color: #606266;
    width: 100%;
}
.box-list-export-order{
    height: 520px;
    border: 1px solid #0000001F;
    border-radius: 4px;
    background-color: white !important;
}
.count-select-shop{
    background: #1D8649 0% 0% no-repeat padding-box;
    border-radius: 14px;
    font-size: 10px;
    color: #FFFFFF;
    letter-spacing: 0.15px;
    padding: 4px 16px;
    font-family: kanit;
}
.table-order-list-count{
    box-shadow: unset !important;
    max-height: 500px
}
.button-process{
    color: white;
    background-color: #367E7F;
    font-weight: 400;
    font-size: 14px;
    width: 90px;
    height: 40px;
}
.button-clear{
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    width: 90px;
    height: 40px;
}
.export-order-box-all-shop {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px 11px;
    letter-spacing: 0.29px;
    color: $txt-color;
    font-weight: 400;
    font-family: kanit;
}
.q-checkbox-all-shop {
    color: #1D8649;
    .q-checkbox__inner--truthy {
        color: #1D8649;
    }
    .q-checkbox__inner--indet {
        color: #1D8649;
    }
}
.box-all-and-choose-shop-list-item-shopname {
    display: flex;
    align-items: flex-start;
}
.box-all-and-choose-shop-list-item {
    font-size: 14px;
    letter-spacing: 0.48px;
    color: $txt-color;
    font-weight: normal;
    .q-checkbox__inner--truthy {
        color: #1D8649;
    }
}
.box-list-export-order-select {
    font-size: 14px;
    color: #303133;
    font-weight: normal;
}
.export-order-box-choose-shop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    margin-bottom: 6px;
}
.export-order-table-head {
    font-size: 14px;
    letter-spacing: 0.21px;
    color: white;
}
.no-data-box {
    height: 100px;
    text-align: center;
    .txt-no-data {
        font-size: 18px;
        line-height: 21px;
        color: #000000;
    }
}

.button-export-order-all{
    font-size: 14px;
    text-align: right;
    color: #FFFFFF;
    background: #367E7F;
    border-radius: 4px;
    padding: 8px 20px;
}
.text-option-date{
    font-size: 13px;
    padding-right: 20px;
    letter-spacing: 1.69px;
    color: #00000099;
    font-weight: 400;
    font-family: kanit;
}
.background-main-page{
    background-color: white;
    padding: 40px 18px;
    margin-left: 0px !important;
    margin-right: 0px !important;
}
.divider-export-width{
    @media screen and (min-width: 1900px) {
        width: 111%;
    }
    @media screen and (max-width: 1340px) {
        width: 120%;
    }
    width: 115.5%;
    margin: 24px -92px;
}
.background-table-page{
    background-color: white;
}
.btn-order-product-download {
    width: 106px;
    height: 32px;
    font-size: 14px;
    color: $txt-color;
    i {
        font-weight: 800;
    }
}
.export-order-datepick {
    width: 100%;
    .el-range-separator {
        padding: 0px;
    }
}
.checkbox-in-select {
    width: 100%;
}
.header-box {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #000000;
    margin-bottom: 30px;
}
.tab-box {
    padding: 20px;
    border-right: 1px solid #EBEEF4;
    border-left: 1px solid #EBEEF4;
    border-bottom: 1px solid #EBEEF4;
}
.margin-t-10 {
    margin-top: -10px
}
.user-code {
    padding-right: 8px;
    line-height: 1.3;
}
.shop-name {
    line-height: 1.3
}
.div-virtual-box {
    padding: 1px 13px;
}
.virtual-box {
    max-height: 370px;
    border: unset !important;
}
.table-select-box {
    border-bottom: 1px solid;
    th {
        background-color: #000000;
        border-color: #000000;
        color: white;
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: unset;
}
::v-deep .el-tabs--border-card {
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    background-color: #ffffff;
}
::v-deep .el-tabs__header {
    margin: unset;
}
::v-deep .el-date-editor .el-range-separator {
    padding: 0 0;
}
::v-deep .q-checkbox__inner {
    font-size: 36px;
}
::v-deep .el-form-item__label {
    color: $txt-color;
}
::v-deep .q-checkbox__bg {
    border: 1.5px solid #DCDFE5;
}
::v-deep .fit {
    width: 75% !important;
    height: 75% !important;
}
::v-deep .absolute-full {
    top: 2px;
    right: 0;
    bottom: 0;
    left: 2px;
}
::v-deep .q-table--horizontal-separator tbody tr:not(:last-child) td {
    border-bottom-width: 0px;
}
::v-deep .q-table > thead > tr {
    height: 37px;
    border-bottom: 1px solid;
}
</style>
<style lang="sass">
.thead-sticky tr > *,
.tfoot-sticky tr > *
  position: sticky
  opacity: 1
  z-index: 1
  background: white
.thead-sticky tr:last-child > *
  top: 0

.tfoot-sticky tr:first-child > *
  bottom: 0
</style>
